module.exports = __webpack_public_path__ + "static/media/business.a9272eb5.jpg";